module.exports = __webpack_public_path__ + "img/1d937ca604ec4d890b0b88085d03afdf.png";